/* ids-mcz-subsidie.js — Tracking & interaction voor Mijn Cyberweerbare Zaak 2026 */
(function () {
  'use strict';

  var TRACKING_KEY = 'ids_b2b_tracking_params_v19_3';
  var REFERRAL_SOURCE = 'mcz_2026';

  /* ── Attribution — shared sessionStorage key met rest van site ─ */
  function collectAndStoreUTMs() {
    var params = {};
    try {
      var s = sessionStorage.getItem(TRACKING_KEY);
      if (s) params = JSON.parse(s);
    } catch (e) {}

    var sp = new URLSearchParams(window.location.search);
    ['gclid','fbclid','gbraid','wbraid','gad_source',
     'utm_source','utm_medium','utm_campaign','utm_content','utm_term'
    ].forEach(function (k) {
      var v = sp.get(k);
      if (v) params[k] = v;
    });

    if (!params.landing_page) params.landing_page = window.location.href;
    if (!params.referrer)     params.referrer = document.referrer || '';

    /* KRITIEK: schrijf referral_source zodat het training-formulier
       dit oppikt als de gebruiker doorklikkt vanuit MCZ.
       De waarde blijft bestaan via ids_b2b_tracking_params_v19_3
       totdat de sessie wordt afgesloten. */
    params.referral_source = REFERRAL_SOURCE;

    try { sessionStorage.setItem(TRACKING_KEY, JSON.stringify(params)); } catch (e) {}
    return params;
  }

  /* ── dataLayer push — geen PII ─────────────────────────────── */
  function push(name, extra) {
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: name }, extra || {}));
    } catch (e) {}
  }

  /* ── CTA click tracking ─────────────────────────────────────── */
  var CTA_MAP = {
    'ncsc_check':        'mcz_ncsc_check_click',
    'rvo':               'mcz_rvo_click',
    'source_rvo':        'mcz_rvo_click',
    'source_ncsc_check': 'mcz_ncsc_check_click',
    'measures_training': 'mcz_idenscan_training_click',
    'human_training':    'mcz_idenscan_training_click',
    'route_idenscan':    'mcz_idenscan_training_click',
    'ids_training':      'mcz_idenscan_training_click',
    'final_training':    'mcz_idenscan_training_click',
    'ids_cybercheck':    'mcz_cybercheck_click',
    'final_cybercheck':  'mcz_cybercheck_click',
  };

  function bindClicks() {
    var root = document.getElementById('ids-mcz-page');
    if (!root) return;
    root.addEventListener('click', function (e) {
      var el = e.target.closest('[data-mcz-cta]');
      if (!el) return;
      var cta = el.getAttribute('data-mcz-cta');
      var evt = CTA_MAP[cta];
      if (evt) push(evt, { cta_id: cta });
    });
  }

  /* ── Section visibility events ──────────────────────────────── */
  function bindSectionObserver() {
    if (!window.IntersectionObserver) return;
    var fired = {};
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var section = entry.target.getAttribute('data-mcz-section');
        if (section && !fired[section]) {
          fired[section] = true;
          if (section === 'eligibility') push('mcz_eligibility_view');
          if (section === 'measures')    push('mcz_measures_view');
          obs.unobserve(entry.target);
        }
      });
    }, { threshold: .25 });
    document.querySelectorAll('[data-mcz-section]').forEach(function (el) {
      obs.observe(el);
    });
  }

  /* ── Init ───────────────────────────────────────────────────── */
  function init() {
    var params = collectAndStoreUTMs();
    push('mcz_landing_view', {
      utm_source:      params.utm_source  || '',
      utm_medium:      params.utm_medium  || '',
      lead_source:     REFERRAL_SOURCE,
    });
    bindClicks();
    bindSectionObserver();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
